<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="page_5"></a>CONTENTS</h2>
<p class="image"><img alt="Illustration" src="images/com.jpg"/></p>
<p class="toc"><a href="#/xhtml/chapter01">Across the Millenia</a></p>
<p class="toc"><span href="#/xhtml/chapter02" title="Link target outside of Sample">Yin and Yang</span></p>
<p class="toc"><span href="#/xhtml/chapter03" title="Link target outside of Sample">The Eight Trigrams</span></p>
<p class="toc"><span href="#/xhtml/chapter04" title="Link target outside of Sample">Reading Hexagrams</span></p>
<p class="toc"><span href="#/xhtml/chapter05" title="Link target outside of Sample">Casting with Yarrow</span></p>
<p class="toc"><span href="#/xhtml/chapter06" title="Link target outside of Sample">Divining with Coins and Staves</span></p>
<p class="toc"><span href="#/xhtml/chapter07" title="Link target outside of Sample">Feng Shui Charms</span></p>
<p class="toc1"><span href="#/xhtml/bm01" title="Link target outside of Sample"><em>Appendix One</em> Lines of Thought</span></p>
<p class="toc1"><span href="#/xhtml/bm02" title="Link target outside of Sample"><em>Appendix Two</em> Crossing the River</span></p>
<p class="toca"><span href="#/xhtml/bm03" title="Link target outside of Sample">ACKNOWLEDGEMENTS</span></p>
<p class="parat">NOTE: To benefit from the full depth of meaning of <em>I Ching,</em> the original, full text should be consulted. In this volume, only key words of guidance have been used in abbreviated form. It is impossible to convey all the subtleties of the original.</p>
<div class="pagebreak">
<p class="imagea"><a id="page_6"></a><img alt="Illustration" src="images/f0006-01.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?5338403a